export default class TerminationOption {
  constructor(
  isSure,
  date,
  isFinePresented,
  isFineWillBePayed,
  externalId,
  currencyCode,
  rate,
  paymentDate,
  ) {
    this.isSure = isSure;
    this.date = date;
    this.isFinePresented = isFinePresented;
    this.isFineWillBePayed = isFineWillBePayed;
    this.externalId = externalId;
    this.currencyCode = currencyCode;
    this.rate = rate;
    this.paymentDate = paymentDate;
  }

  static createFromData(data) {
    if (data == null) return null;
    return new TerminationOption(
      data.isSure,
      data.date,
      data.isFinePresented,
      data.isFineWillBePayed,
      data.externalId,
      data.currencyCode,
      data.rate,
      data.paymentDate,
    )
  }

  static createNew() {
    return new TerminationOption(
      false,
      null,
      false,
      false,
      null,
      null,
      null,
      null,
    );
  }

}
